import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

// Syntax-Hervorhebung für Code-Blöcke
function CodeBlock({ language, code }) {
  // If code is empty or only whitespace, don't render the syntax highlighter
  if (!code || code.trim() === '') {
    return null;
  }
  
  return (
    <div className="rounded overflow-hidden mb-4">
      <SyntaxHighlighter
        language={language || "text"}
        style={vscDarkPlus}
        className="text-sm"
        customStyle={{ margin: 0, padding: "1rem" }}
        showLineNumbers={true}
      >
        {code}
      </SyntaxHighlighter>
    </div>
  );
}

export default CodeBlock;
